import { useTimer } from "@/contexts/TimerContext";
import { Button } from "@/components/ui/button";
import { SrIcon } from "@/components/ui/SrIcon";

function formatElapsed(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
}

/**
 * Fixed bottom bar shown only on mobile (< md) when a timer is running.
 * Desktop uses TimerWidget in AppLayout header instead.
 */
export default function MobileTimerBar() {
  const { activeTimer, elapsedSeconds, stopTimer, isRunning } = useTimer();

  if (!isRunning || !activeTimer) return null;

  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-primary text-primary-foreground border-t border-primary/40 shadow-lg">
      <div className="flex items-center gap-3 px-4 py-3 max-w-screen-sm mx-auto">
        <SrIcon name="clock" className="w-4 h-4 animate-pulse shrink-0"  />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium truncate">{activeTimer.projectName}</p>
          {activeTimer.taskDescription ? (
            <p className="text-xs opacity-80 truncate">{activeTimer.taskDescription}</p>
          ) : null}
        </div>
        <span className="text-base font-mono font-bold tabular-nums shrink-0">
          {formatElapsed(elapsedSeconds)}
        </span>
        <Button
          size="sm"
          variant="secondary"
          className="h-9 px-3 shrink-0"
          onClick={stopTimer}
          title="Stopp timer"
        >
          <SrIcon name="square" className="w-3.5 h-3.5 fill-current mr-1"  />
          Stopp
        </Button>
      </div>
    </div>
  );
}
